import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "history",
  "use": "history-usage",
  "viewBox": "0 0 544 512",
  "content": "<symbol viewBox=\"0 0 544 512\" id=\"history\"><path d=\"M320 32c123.712 0 224 100.288 224 224S443.712 480 320 480v-48c47.012 0 91.209-18.307 124.451-51.549S496 303.012 496 256c0-47.011-18.307-91.209-51.549-124.451S367.012 80 320 80c-47.011 0-91.209 18.307-124.451 51.549-25.57 25.569-42.291 57.623-48.653 92.451H240L128 352 16 224h82.285C113.815 115.449 207.154 32 320 32zm96 192v64H288V128h64v96z\" /></symbol>"
});
var result = sprite.add(symbol);
export default "#" + symbol.id


//////////////////
// WEBPACK FOOTER
// ./src/assets/svg/history.svg
// module id = iDeL
// module chunks = 1